module.exports = __webpack_public_path__ + "posicoes_na_fila.png?cd97c75e69f8939d9b101242d6ee62cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posicoes_na_fila.png
// module id = 430
// module chunks = 0